module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione1 b.e880f320.svg";